import type { VirtualGridOverlayApiT } from '../../../../common/virtual-grid';
import { useFrameAutoScroll } from '../../hooks/use-frame-autoscroll';
import { useSelectionAutoScroll } from '../../hooks/use-selection-autoscroll';
import { useSpanResizeAutoScroll } from '../../hooks/use-span-resize-autoscroll';
type PropsT = {
  overlayControls: VirtualGridOverlayApiT;
  totalFrames: number;
};

/**
 * Headless host for the timeline's autoscroll subscriptions (playhead, selection, resize
 * preview). It renders `null` on purpose: keeping these atom subscriptions off the marker's
 * render path means the visible marker only re-renders when the current frame actually moves,
 * not on every resize-drag tick or selection change.
 */
export const TimelineAutoScroll = ({
  overlayControls,
  totalFrames
}: PropsT) => {
  useFrameAutoScroll(overlayControls.scrollToColumn, totalFrames);
  useSelectionAutoScroll(overlayControls.scrollToRow, overlayControls.scrollToColumn);
  useSpanResizeAutoScroll(overlayControls.scrollToColumn, totalFrames);
  return null;
};